import { axiosInstance } from './axios';
import { InterviewStage, InterviewNote } from '../../types/interview';

export const interviewApi = {
  createInterview: async (applicationId: number, stageName: string) => {
    const response = await axiosInstance.post('/interview/stages', {
      name: stageName,
      order: 1
    }, {
      params: {
        application_id: applicationId
      }
    });
    return response.data;
  },

  getInterviews: async (applicationId: number, jobId: number) => {
    const response = await axiosInstance.get(`/interview/stages/${jobId}`, {
      params: { application_id: applicationId }
    });
    return response.data;
  },

  updateInterviewStage: async (stageId: number, data: {
    name: string;
    order: number;
  }) => {
    const response = await axiosInstance.put(`/interview/stages/${stageId}`, data);
    return response.data;
  },

  deleteInterviewStage: async (stageId: number) => {
    const response = await axiosInstance.delete(`/interview/stages/${stageId}`);
    return response.data;
  },

  addNote: async (data: {
    application_id: number;
    interview_id: number;
    job_id: number;
    user_id: string;
    content: string;
    feedback?: Record<string, any>;
  }) => {
    const response = await axiosInstance.post('/interview/notes', data);
    return response.data;
  },

  getNotes: async (applicationId: number, interviewId: number, jobId: number, userId: string) => {
    const response = await axiosInstance.get(
      `/interview/notes/${applicationId}/${jobId}`
    );
    return response.data;
  },

  getApplicationIdForInterview: async (interviewId: string) => {
    const response = await axiosInstance.get(`/interview/interviews/${interviewId}/application`);
    return response.data.application_id;
  }
}; 